/* eslint-disable */
let imageWidth = 0;
let windowWidth = 0;
let windowHeight = 0;
export default {
  init() {
    $(document).ready(function () {
      // Wrap every letter in a span
      var highlightedText = document.querySelector(".letters .white");
      highlightedText.innerHTML = highlightedText.textContent.replace(
        /\S/g,
        "<span class='white letter'>$&</span>"
      );

      var orangeSpans = document.querySelectorAll(
        ".letters :not(.white):not(br)"
      );

      orangeSpans.forEach((span) => {
        span.innerHTML = span.textContent.replace(
          /\S/g,
          "<span class='letter'>$&</span>"
        );
      });

      document.getElementsByClassName("letters")[0].style.opacity = "1";

      anime
        .timeline({ loop: false })

        .add({
          targets: ".ml1 .letter",
          scale: [0.3, 1],
          opacity: [0, 1],
          translateZ: 0,
          easing: "easeOutExpo",
          duration: 600,
          delay: (el, i) => 70 * (i + 1),
        })
        .add({
          targets: ".ml1 .line",
          scaleX: [0, 1],
          opacity: [0.5, 1],
          easing: "easeOutExpo",
          duration: 700,
          offset: "-=875",
          delay: (el, i, l) => 80 * (l - i),
        });
    });

    // JavaScript to be fired on the home page
    $(document).ready(function () {
      function changeProject() {
        var projectText = ["Solutions", "Results", "Innovations"];
        var counter = 0;
        var elem = document.getElementById("project-overview-text");

        elem.innerHTML = projectText[0];

        function change() {
          elem.innerHTML = projectText[counter];
          counter++;
          if (counter >= projectText.length) {
            counter = 0;
          }
        }

        let timerId = setTimeout(function time() {
          timerId = setTimeout(time, 3000);
          change();
        }, 3000);
      }
      changeProject();

      function changeClient() {
        var clientText = ["Subject Experts", "Clients", "End Users"];
        var counter = 0;
        var elem = document.getElementById("client-overview-text");

        elem.innerHTML = clientText[0];

        function change() {
          elem.innerHTML = clientText[counter];
          counter++;
          if (counter >= clientText.length) {
            counter = 0;
          }
        }

        let timerId = setTimeout(function time() {
          timerId = setTimeout(time, 3000);
          change();
        }, 3000);
      }
      changeClient();
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    $(document).ready(function () {
      // Load the services carousel
      servicesSwiper.init();
    });
  },
};

let servicesSwiper = {
  init: () => {
    $(".service-overview .grid-wrapper").slick({
      centerMode: true,
      centerPadding: "60px",
      slidesToShow: 3,
      rows: 0,
      dots: true,
      responsive: [
        {
          breakpoint: 9999,
          settings: "unslick",
        },
        {
          breakpoint: 640,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: "40px",
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: "40px",
            slidesToShow: 1,
          },
        },
      ],
    });

    $(window).on("resize orientationchange", function () {
      $(".service-overview .grid-wrapper").slick("resize");
    });
  },
};

var tiltTheHero = {
  init: () => {
    console.log("loaded");
    // if ('DeviceOrientationEvent' in window) {
    window.addEventListener("deviceorientation", tiltTheHero.doHeroTilt, false);
    // } else {
    // document.getElementById('logoContainer').innerText = 'Device Orientation API not supported.';
    // }
  },
  doHeroTilt: (eventData) => {
    console.log(eventData);
    var tiltLR = eventData.gamma;
    var tiltFB = eventData.beta;
    var dir = eventData.alpha;

    // document.getElementById("doTiltLR").innerHTML = Math.round(tiltLR);
    // document.getElementById("doTiltFB").innerHTML = Math.round(tiltFB);
    // document.getElementById("doDirection").innerHTML = Math.round(dir);

    var images = document
      .getElementById("parallax-scene")
      .getElementsByTagName("img");

    var windowWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    Object.keys(images).forEach((key) => {
      if (images[key].className == "front-page-hero__media") {
        let imageWidth = images[key].clientWidth,
          imageHeight = images[key].clientHeight;
        // console.log(imageWidth);
        // console.log(imageHeight);
        console.log(imageWidth - windowWidth);
        images[key].style.webkitTransform =
          "translate3d(" + tiltLR + "px, 0px, 0px)";
      }
      // console.log(key);          // the name of the current key.
      // console.log(images[key].className);   // the value of the current key.
    });
  },
};

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}



// WEBPACK FOOTER //
// ./scripts/routes/home.js